module.exports = __webpack_public_path__ + "img/fs_11.18ee8cb3.jpg";